module.exports = __webpack_public_path__ + "img/image-polaroid-user.d400085b.svg";